// Copyright (c) 2020 Deere & Company

import MassLaborRateChangeContainer from '../../claim/mass-labor-rate-change/state-connector';

export default {
    component: MassLaborRateChangeContainer,
    name: 'MULTIPLE',
    path: 'update-labor-rates/multiple'
};



// WEBPACK FOOTER //
// ./src/routes/claims/mass-labor-rate-change.js